import { companyUUID } from '@/service/api';
import { debug as CreateDebug } from 'debug';

const debug = CreateDebug('cartsee:shopify');

export const isShopifyHydrogen = () => {
  return window?.CARTSEE_SUBSCRIBE?.config?.hydrogen === true;
};


export interface Variant {
  skuId: string | number;
  skuTitle: string;
  available: boolean;
}

const SKU_INFO_DISPLAY_COMPANIES = ['lbud46je'];

/**
 * 渲染缺货通知按钮
 * 
 * 当商品变体缺货时，显示"到货通知"按钮，并将变体信息存储在 DOM 中供弹窗使用
 * 
 * @param variant - 商品变体信息
 * @param wrapper - 按钮容器元素
 * 
 * @example
 * ```typescript
 * // 在 Hydrogen 中使用
 * window.cartsee = window.cartsee || [];
 * window.cartsee.push([
 *   'variant:changed',
 *   {
 *     skuId: variant.id,
 *     skuTitle: variant.title,
 *     available: variant.availableForSale
 *   },
 *   buttonWrapper
 * ]);
 * ```
 */
export const renderSoldOutButton = (variant: Partial<Variant> = {}, wrapper: HTMLElement) => {
  const soldOutButtonConfig = window._cartx_sold_button_config || {};

  let triggerWrapper = document.querySelector('.cartx-popup-trigger-wrapper') as HTMLDivElement;
  if (!triggerWrapper) {
    triggerWrapper = document.createElement('div');
    triggerWrapper.setAttribute('class', 'cartx-popup-trigger-wrapper');
    triggerWrapper.style.display = 'none';

    const trigger = document.createElement('button');
    trigger.setAttribute('class', `cartx-popup-trigger ${soldOutButtonConfig.soldOutBtnClass || 'button'}`);
    trigger.innerText = `${soldOutButtonConfig.soldOutBtnText || 'Notify Me When Available'}`;

    triggerWrapper.appendChild(trigger);
    wrapper.appendChild(triggerWrapper);
  } else {
    // 判断是否已经添加过
    const existingTrigger = triggerWrapper.querySelector('.cartx-popup-trigger');
    if (!existingTrigger) {
      // 补充按钮元素
      const trigger = document.createElement('button');
      trigger.setAttribute('class', `cartx-popup-trigger ${soldOutButtonConfig.soldOutBtnClass || 'button'}`);
      trigger.innerText = `${soldOutButtonConfig.soldOutBtnText || 'Notify Me When Available'}`;

      // 将我们按钮加到客户制定容器中
      triggerWrapper.appendChild(trigger);
    }
  }

  const { skuTitle, skuId, available } = variant;

  // 存储当前变体信息，供弹窗展示使用
  if (skuTitle && SKU_INFO_DISPLAY_COMPANIES.includes(companyUUID)) {
    triggerWrapper.setAttribute('data-sku-id', String(skuId));
    triggerWrapper.setAttribute('data-sku-title', skuTitle);
    triggerWrapper.setAttribute('data-available', String(available));
  }

  // TODO 缺货判断：准确性校验
  debug('商品缺货状态 variant=%o', variant);
  if (available === false) {
    triggerWrapper.style.display = 'block';
  } else {
    triggerWrapper.style.display = 'none';
  }
};

/**
 * 获取当前存储的变体信息
 * @returns 变体信息对象，如果未找到则返回 null
 */
export const getCurrentVariant = (): Variant | null => {
  const triggerWrapper = document.querySelector('.cartx-popup-trigger-wrapper') as HTMLDivElement;
  if (!triggerWrapper) {
    return null;
  }

  const skuId = triggerWrapper.getAttribute('data-sku-id');
  const skuTitle = triggerWrapper.getAttribute('data-sku-title');
  const available = triggerWrapper.getAttribute('data-available');

  if (!skuId || !skuTitle) {
    return null;
  }

  return {
    skuId,
    skuTitle,
    available: available === 'true'
  };
};
